import { useCallback, useEffect, useRef } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import I18n from 'I18n';
import { useDispatch } from 'react-redux';
import { UsageTrackerUtils } from 'feature-unboxing-common';
import { StepLayout } from './StepLayout';
import useChatSlice from '../hooks/useChatSlice';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import debounce from 'hs-lodash/debounce';
import { NextButton } from './Wizard/NextButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  TrackerActions
} = UsageTrackerUtils;
export default function FirstStep({
  step,
  onNext
}) {
  const dispatch = useDispatch();
  const {
    chat: {
      firstName,
      lastName,
      companyName,
      companyDomain
    },
    set,
    setCompanyDomain
  } = useChatSlice();
  const debouncedSetCompanyDomain = useRef(debounce(newCompanyDomain => setCompanyDomain(newCompanyDomain), 500)).current;
  const handleInputChange = useCallback(async newCompanyDomain => {
    set({
      companyDomain: newCompanyDomain
    });
    await debouncedSetCompanyDomain(newCompanyDomain);
  }, [debouncedSetCompanyDomain, set]);
  useEffect(() => {
    dispatch(TrackerActions.trackPageView({
      screen: 'first-step'
    }));
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(StepLayout, {
    step: 1,
    i18nKey: "firstStep",
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.firstStep.firstName"
      }),
      children: /*#__PURE__*/_jsx(TextInput, {
        name: "firstName",
        placeholder: I18n.text('app.firstStep.firstNamePlaceholder'),
        value: firstName,
        onChange: e => set({
          firstName: e.currentTarget.value
        }),
        "data-test-id": "first-name-input"
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.firstStep.lastName"
      }),
      children: /*#__PURE__*/_jsx(TextInput, {
        name: "lastName",
        placeholder: I18n.text('app.firstStep.lastNamePlaceholder'),
        value: lastName,
        onChange: e => set({
          lastName: e.currentTarget.value
        }),
        "data-test-id": "last-name-input"
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.firstStep.companyName"
      }),
      children: /*#__PURE__*/_jsx(TextInput, {
        name: "companyName",
        placeholder: I18n.text('app.firstStep.companyNamePlaceholder'),
        value: companyName,
        onChange: e => set({
          companyName: e.currentTarget.value
        }),
        "data-test-id": "company-name-input"
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.firstStep.companyDomain"
        }), /*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.firstStep.companyDomainTooltip"
          }),
          marginInlineStart: "100"
        })]
      }),
      children: /*#__PURE__*/_jsx(TextInput, {
        name: "companyDomain",
        placeholder: I18n.text('app.firstStep.companyDomainPlaceholder'),
        value: companyDomain,
        onChange: e => {
          handleInputChange(e.currentTarget.value).catch(err => {
            console.error(err);
          });
        },
        "data-test-id": "company-domain-input"
      })
    }), /*#__PURE__*/_jsx(NextButton, {
      step: step,
      onClick: onNext
    })]
  });
}